import getDomainPlatform, {
  DomainPlatformValue,
} from '@/utils/getDomainPlatform';
import getAppClient, { AppClientValue } from '@/utils/getAppClient';
import { setSubject } from '@/utils/subject';
import useConfigStore from './useConfigStore';
import useThemeStore from './useThemeStore';
import studentTheme from './studentTheme';

// 应用启动初始化（模块加载即执行）：
// 按域名识别平台（IPE 思政站 / FS 默认站），注入平台名、功能开关与整套主题 token；
// 学生端 App 再叠加 studentTheme。
function init() {
  document.title = '卅三智慧教育科技';
  const domainPlatform = getDomainPlatform();

  if (domainPlatform === DomainPlatformValue.Ipe) {
    // IPE 思政教学辅助系统：红色系主题 + 高校配置，整体覆盖 FS 默认值
    const platformTitle = '思政教学辅助系统';

    useConfigStore.setState({
      hasLoginSubjectSelector: false,
      hasAudienceScopeVisibleSelect: true,
      platformName: platformTitle,
      isUniversity: true,
    });

    document.title = platformTitle;

    useThemeStore.setState({
      antdThemeColor: 'rgba(253, 60, 55, 1)',
      hasMainLayoutHeaderBg: true,
      mainLayoutHeaderTextColor: '#fff',
      mainLayoutHeaderUserSpaceIcon: 1,
      mainLayoutHeaderUserSpaceBg: 'rgba(255, 255, 255, 0.2)',
      mainLayoutHeaderUserSpaceSpanBg: 'rgba(177, 138, 100, 1)',
      mainLayoutHeaderUserSpaceSpanColor: '#fff',

      stepBlockBgColor: 'rgba(252, 177, 111, 0.1)',
      stepBlockTextColor: 'rgba(247, 136, 65, 1)',
      sidePanelLinkColor: 'rgba(192, 25, 32, 1)',

      fileCardBgColor:
        'linear-gradient(90.00deg, rgba(255, 255, 255, 1) 50%,rgba(255, 251.05, 245.51, 1) 100%)',
      fileCardBorder: '1px solid rgba(0, 0, 0, 0.08)',
      fileCardBorderActiveColor: 'rgba(194, 137, 58, 1)',
      fileCardBgPng: 1,
      fileCardSmartGeneratePng: 1,

      chatSendBtnBgColor: 'rgba(177, 138, 100, 1);',
      chatSendBtnBgHoverColor: 'rgba(159, 124, 90, 1)',

      chatSenderBorder: '0.8px solid rgba(199, 199, 199, 1)',
      chatSenderHoverBorder: 'rgba(253, 60, 55 ,0.5)',
      chatSenderHoverBoxShadow: 'rgba(253,60,55 ,0.16)',
      chatBubbleLoadingSvg: 1,
      chatSenderResetFormButtonBg:
        'linear-gradient(to right, #fdf8fd, rgba(241, 127, 65, 0.2), #f8fbfe)',
      chatSenderResetFormButtonBefore:
        'linear-gradient(90deg, rgba(255, 89, 89, 0.3), rgba(241, 127, 65, 0.4))',
      chatSenderResetFormButtonHoverBg: `linear-gradient(90.00deg, rgba(255, 89, 89, 0.08),rgba(241, 127, 65, 0.08) 100%),rgba(255, 255, 255, 1)`,
      chatSenderResetFormButtonIcon: 1,

      thinkDeeplyBtnColor: 'rgba(192, 25, 32, 1)',
      thinkDeeplyBtnBorder: '1px solid rgba(192, 25, 32, 0.3)',
      thinkDeeplyBtnBgColor: 'rgba(192, 25, 32, 0.05)',
      thinkDeeplyActiveIcon: 1,
      hasMainLayoutSiderBg: true,
      mainLayoutSiderContentColor: 'rgba(192, 25, 32, 1)',
      mainLayoutSiderContentBg: 'rgba(192, 25, 32, 0.12)',
      mainLayoutSiderContentBorder: 'rgba(192, 25, 32, 0.25)',
      mainLayoutSiderContentIcon: 1,
      mainLayoutSiderContentSelectedBg: 'rgba(247, 136, 65, 0.12)',
      mainLayoutSiderContentSelectedColor: 'rgba(192, 25, 32, 1)',
      mainLayoutSiderContentHoverBg: 'rgba(247, 136, 65, 0.06)',
      mainLayoutSiderNewChatHoverBg: 'rgba(192, 25, 32, 0.18)',
      mainLayoutSiderNewChatIcon: 1,

      mainLayoutSiderHistorySessionIcon: 1,
      mainLayoutSiderHistorySessionCurrent: 'rgba(247, 136, 65, 0.12)',
      mainLayoutSiderHistorySessionText: 'rgba(37, 40, 43, 1)',
      mainLayoutSiderHistorySessionHoverBg: 'rgba(247, 136, 65, 0.06)',

      teachingPlanFormLessonIcon: 1,
      teachingPlanFormUnitIcon: 1,
      agentFormHeaderCardBorderColor: 'rgba(192, 25, 32, 1)',
      agentFormHeaderCardBackgroundColor: 'rgba(192, 25, 32, 0.08)',
      agentFormBodySwitchColor: 'rgba(212, 176, 121, 1), rgba(194, 137, 58, 1)',
      agentFormBodyRadioCheckboxColor: 'rgba(192, 26, 33, 1)',
      agentFormActionDownBorderColor: '#C2893A, #C6A46C',
      agentFormActionDownColor: 'rgba(194, 137, 58, 1)',
      agentFormSubmitHoverColor: 'rgba(255, 105, 100, 1)',
      agentFormActionDownHoverColor: 'rgba(249, 243, 236, 1)',
      teachingPlanFormActionButtonBackgroundColor: 'rgba(253, 60, 55, 1)',
      teachingPlanFormActionButtonHoverColor: 'rgba(255, 105, 100, 1)',
      agentFormCustomTextAreaHoverColor: 'rgba(253, 60, 55, 1)',

      commonTabGroupColor: 'rgba(192, 25, 32, 1)',
      coursewareCreateButtonBgColor: 'rgba(253, 60, 55, 1)',
      coursewareCreateButtonBgHoverColor: 'rgba(255, 105, 100, 1)',
      coursewareGotoCommunityImg: 1,

      coursewareEmptyActionTextColor: 'rgba(192, 25, 32, 1)',
      coursewareEmptyCollaboratedImg: 1,
      coursewareEmptyUsedImg: 1,

      dropDownMeunColor: '#6E7880',

      coursewarePublishButtonBgColor: 'rgba(253, 60, 55, 1)',
      coursewarePublishButtonBgHoverColor: 'rgba(255, 105, 100, 1)',

      coursewareDetailBgColor: '#FFFFFF',
      coursewareScenesStepsBgColor: 'rgba(192, 25, 32, 0.06)',

      coursewareDetailCenterModuleIntroCardBgColor: 'rgba(251, 246, 240, 1)',

      coursewareInfoTabsActiveColor: 'rgba(171, 49, 56, 1)',

      filterBorderColor: 'rgba(199, 199, 199, 0.4)',
      filterHoverBorderColor: 'rgba(253, 60, 55, 1)',
      filterActiveBorderColor: 'rgba(253, 60, 55, 1)',

      resourceCreationUploadBorder: '1px dashed rgba(255, 89, 89, 0.4)',
      resourceCreationUploadHoverBorder: '1px dashed rgba(253, 60, 55, 1)',
      resourceCreationUploadBgColor: 'rgba(255, 89, 89, 0.06)',
      resourceCreationUploadHoverBgColor: 'rgba(255, 89, 89, 0.12)',
      resourceCreationUploadProgressStartColor: 'rgba(212,176,121,1)',
      resourceCreationUploadProgressEndColor: 'rgba(194, 137, 58, 1)',
      resourceCreationBtnBgColor: 'rgba(253, 60, 55, 1)',
      resourceCreatButtonBgColor: 'rgba(253, 60, 55, 1)',
      resourceCreatButtonHoverBgColor: 'rgba(255, 105, 100, 1)',

      agentUploadEmptyBg: 'rgba(194, 137, 58, 0.06)',
      agentUploadEmptyBorder: '1px dashed rgba(194, 137, 58, 0.8)',
      agentUploadEmptyHoverBg: 'rgba(194, 137, 58, 0.12)',
      agentUploadEmptyHoverBorder: '1px dashed rgba(194, 137, 58, 1)',

      emptyWithCreateQuickPanBgColor: 'rgba(249, 248, 246, 1)',
      emptyWithCreateQuickPanBgHoverColor: 'rgba(249, 248, 246, 1)',
      emptyWithCreateQuickPanBtnBorderColor: 'rgba(177, 138, 100, 0.45)',
      emptyWithCreateQuickPanBtnTextColor: 'rgba(177, 138, 100, 1)',
      emptyWithCreateQuickPanBtnHoverColor: 'rgba(177, 138, 100, 1)',

      emptyQualityImg: 1,
      emptyUnitKnowledgePointImg: 1,

      loginSignInBackground: 2,
      loginSignInSlogan: false,
      loginSignInFormTitle: '思政教学辅助系统',
      hasLoginSignInFormLogo: false,
      loginSignInSubjectSelect: false,
      loginSignInCaptchaButtonColor: '#c01920',
      loginSignInAgreement: 'ipe',
      loginSignInAgreementCheckboxColor: '#c01920',
      loginSignInFormBackground: 1,

      hiddenLogo: true,

      settingsLeftNavPersonalIcon: 1,
      settingsLeftNavSchoolIcon: 1,
      settingsLeftNavAccountIcon: 1,
      settingsLeftNavAboutIcon: 1,
      settingsAboutTextColor: 'rgba(192, 25, 32, 1)',
      settingsAboutTextHoverColor: 'rgba(154, 20, 26, 1)',
      settingsPersonalAvatarBg: 'rgba(177, 138, 100, 1)',
      settingsPersonalAvatarColor: '#fff',
      settingsPersonalButtonBg: 'rgba(253, 60, 55, 1)',
      settingsAboutTitle: '思政教学辅助系统',
      settingsContractItemTitle: '思政教学辅助系统用户协议',
      settingsAboutAgreement: 'ipe',

      moduleTabsBgColor: '#fdf5f5',
      moduleTabsHoverBgColor: '#fff2eb',
      moduleTabsBorder: '1px solid rgba(0, 0, 0, 0.1)',
      moduleTabsActiveColor: '#C01920',
      moduleTabsUnitGuideColor: '#C01920',
      moduleTabsModuleIcon: 2,
      moduleTabsSelectedBorderGradient:
        'linear-gradient(to right, #D4B079, #C2893A)',

      playerBackgroundColor: 'rgba(192, 25, 32, 0.1)',
      playerIntroBoxColorBar: 2,
      playerGuideButtonIcon: 2,
      playerDigitalHumanBoxBg: 2,
      playerColourStyle: 2,
      playerEmptyImage: 2,
      unitGuideLayoutstyle: 2,

      hasChatWelcomeTitleBg: true,
      chatPaddingTop: '50px',
      chatToolListConfig: 1,
      chatToolListItemBg: 'rgba(249, 235, 232, 1)',
      chatToolListItemTagBg:
        'linear-gradient( 90deg, rgba(255, 89, 89, 1), rgba(241, 127, 65, 1) 100% )',
      chatToolListItemTextColor: 'rgba(255, 255, 255, 1)',

      notFoundIcon: 1,

      aiPptChatHistoryFavoritesIcon: 1,
      aiPptChatHeaderFavoritesIcon: 1,
      aiPptChatLeftButtonIcon: 1,
      aiPptChatLeftButtonBg: 'rgba(194, 137, 58, 0.14)',
      aiPptChatLeftButtonColor: 'rgba(76, 49, 22, 1)',
      aiPptChatLeftButtonBorder: 'rgba(194, 137, 58, 0.14)',
      aiPptChatSendButtonIcon: 1,
      aiPptChatDeepCreationButtonColor: 'rgba(192, 25, 32, 1)',
      aiPptChatDeepCreationButtonBg: '#f2eaeb',
      aiPptChatDeepCreationButtonHoverBg: '#eedfdf',
      aiPptChatDeepCreationButtonIcon: 1,
      aiPptChatGenerateButtonIcon: 1,
      aiPptChatGenerateButtonHoverColor: 'rgba(192, 25, 32, 1)',
      hasAiPptChatDeepCreationDialogDescribe: false,

      resourceUnitGuideIcon: 1,
      resourceUnitGuideBg: 'rgba(253, 60, 55, 0.08)',
      resourceCommunityTextColor: 'rgba(192, 25, 32, 1)',
      resourceQuickCreateImage: 1,
      resourceQuickUploadImage: 1,
      resourceEmptyScaffoldImage: 1,
      resourceEmptyTeachingImage: 1,

      pptAddedButtonsBgColor: 'rgba(253, 60, 55, 1)',
      pptToolbarSelectedBorderColor: '#C01920',
      pptToolbarBg:
        'linear-gradient(to bottom, rgba(255, 249, 249, 1), rgba(255, 244, 233, 1))',
      pptToolbarHoverBg: 'linear-gradient(to bottom, #FFF9F4, #FFECDA)',
      pptToolbarBorderGradient: 'rgba(177, 138, 100, 1)',
      pptToolbarIllustration: 1,
      pptToolbarTextColor: 'rgba(192, 25, 32, 1)',
      pptToolbarSubTextColor: 'rgba(136, 94, 54, 1)',
      pptToolbarAddedBgColor:
        'linear-gradient(90.00deg, rgba(212, 176, 121, 1),rgba(194, 137, 58, 1) 100%)',

      resourceEmptyCoursewareImage: 1,

      scaffoldingBgColors: 'rgba(212, 90, 75, 1)',
      scenesStepTabsStyle: 2,
      sceneStepTabsIcon: 2,
      stepCardBorderColor: 'rgba(192, 25, 32, 1)',
      pptStepInfoTitleColor: 'rgba(192, 25, 32, 0.6)',
      pptStepInfoIndexColor: 'rgba(192, 25, 32, 1)',
      aigeneratePptImg: 1,

      communityCoursewareImage: 1,
      communityCoursewareBg: 'rgba(253, 60, 55, 0.08)',

      courseWareInfiniteCardButtonColor: 'rgba(253, 60, 55, 1)',
      courseWareInfiniteCardButtonColorHover: 'rgba(255, 105, 100, 1)',
      courseWareInfiniteCardButtonIcon: 1,
      courseWareInfiniteCardUseButtonColor: 'rgba(255, 232, 231, 1)',
      courseWareInfiniteCardUseButtonColorHover: 'rgba(255, 237, 236, 1)',
      courseWareInfiniteCardUseButtonIcon: 1,
      courseWareInfiniteCardUseButtonBorder: 'rgba(253, 60, 55, 0.4)',
      courseWareInfiniteCardUseButtonFontColor: 'rgba(253, 60, 55, 1)',

      learningSpaceDocumentBg: 'rgba(253, 60, 55, 0.08);',
      learningSpaceDocumentImage: 1,

      agentMaterialBgImage: 1,

      thoughtScrollBgColor: 'rgba(246, 246, 246, 0.8)',

      syncButtonText: '我的课件',
      syncButtonConfirmTitle: '同步课件',

      hasCoursewareUsedHref: true,
      coursewareNavigationText: '【我的课件包】',

      detailGoBackBtnText: '返回数智化课件列表页',

      sidePanelEmptyImage: 1,

      scaffoldingHoverColor: 'rgba(192, 25, 32, 1)',

      antdPrimaryColor: 'rgba(253, 60, 55, 1)',
      antdPrimaryHoverColor: 'rgba(255, 105, 100, 1)',
      antdDefaultHoverBoderColor: '#FF6964',
      antdDefaultHoverTextColor: 'rgba(255, 105, 100, 1)',
      antdDefaultHoverBgColor: 'rgba(255, 255, 255, 1)',

      detailePlayerEmptyImage: 1,

      bubbleListBottomFadeMaskBg: `linear-gradient(
                180deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 1) 100%
              )`,
    });

    setSubject({
      id: '100001',
      name: '高校思想政治理论课',
    });
  }

  // 学生端客户端叠加专属主题
  if (getAppClient() === AppClientValue.Student) {
    studentTheme();
  }
}

init();
